import constants from '@constants';

class User {
	constructor(userObj) {
		// Extend initial object received from API
		Object.assign(this, userObj);
	}

	/* User type checks */
	isUserType(userType) {
		return this.UserTypeId === userType;
	}

	isSuperAdmin() {
		return this.UserTypeId === constants.USER_TYPE.SUPER_ADMIN;
	}

	isLEA() {
		return this.UserTypeId === constants.USER_TYPE.LAW_ENFORCEMENT;
	}

	isAgencyAdmin() {
		return this.UserTypeId === constants.USER_TYPE.AGENCY_ADMIN;
	}

	isClient() {
		return this.UserTypeId === constants.USER_TYPE.CLIENT;
	}

	isCoordinator() {
		return this.UserTypeId === constants.USER_TYPE.COORDINATOR;
	}
}

export default User;
